<template>
  <el-container id="el_main">
    <el-main id="full_screen">
      <el-row style="width:100%;height:100%" type="flex" align="middle">
        <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:6,offset:16}">
          <el-card
            id="rgba_background"
            shadow="always"
            v-loading="loading"
            element-loading-text="登陆中"
            element-loading-spinner="el-icon-loading"
            element-loading-background="grba(0,0,0,.6)"
          >
            <div slot="header" style="text-align:center" class="clearfix">
              <span style="font-size:18px;letter-spacing:3px;font-weight:bold">美途消息管理后台</span>
            </div>
            <div>
              <el-form :model="model" ref="f" :rules="rules">
                <el-form-item label="手机号" prop="username">
                  <el-input v-model="model.username" placeholder="| 请输入手机号" />
                </el-form-item>
                <el-form-item label="密码" prop="password">
                  <el-input
                    v-model="model.password"
                    type="password"
                    @keyup.enter.native="login"
                    placeholder="| 请输入密码"
                  />
                  <el-divider />
                  <el-form-item style="text-align:center">
                    <el-button type="primary" @click="login">登录</el-button>
                    <el-button @click="reset">重置</el-button>
                  </el-form-item>
                </el-form-item>
              </el-form>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </el-main>
  </el-container>
</template>

<script>
import User from "../models/User";
export default {
  data: () => ({
    pageModel: new User(),
    loading: false,
    rules: {
      username: [{ required: true, message: "请输入手机号", trigger: "blur" }],
      password: [{ required: true, message: "请输入登录密码", trigger: "blur" }]
    },
    model: {
      username: null,
      password: null
    }
  }),
  methods: {
    login() {
      let _this = this;
      this.$refs.f.validate(valid => {
        if (valid) {
          _this.loading = true;
          _this.pageModel
            .login(this.model.username, this.model.password)
            .then(res => {
              _this.loading = false;
              _this.$store.dispatch("setUser", res.data);
              _this.$router.push({ path: "/" });
            })
            .catch(e => {
              _this.$message({
                type: "error",
                message: e
              });
              _this.loading = false;
            });
        }
      });
    },
    reset() {
      this.$refs.f.resetFields();
    }
  }
};
</script>

<style>
#el_main {
}

#full_screen {
  height: 100vh;
  width: 100vw;
  background-image: url("../assets/lvbao_bg.png");
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
}

#rgba_background {
  background: rgba(255, 255, 255, 0.8);
}
</style>